import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import RevolvingText from './RevolvingText';
import Loader from 'react-loaders';

const Skills = () => {
    const [letterClass, setLetterClass] = useState('text-animate');

    setTimeout(() => {
        setLetterClass('text-animate-hover');
    }, 3000);

    document.title = "Portfolio | Skills";

    return(
        <>
        <div className="container skills-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters letterClass={letterClass} myStr={"Skills"} idx={3} />{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"&"} idx={5} />{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Experience"} idx={7} />
                </h1>
                <p>I have experience in prgramming languages in C, C++, JAVA, Python 3, Dart, Rust, Kotlin, HTML5, CSS, and Java Script.</p>
                <p>I have build many projects in python, built many websites in HTML, CSS and JavaScript, react, and also in blockchain, and have them hosted on github, heroku and other places, visit my <Link to = "/projects">Projects</Link> page and my <a href="https://github.com/SoumyadevSaha" target="_blank" rel="noreferrer">GitHub</a> profile for more.</p>
                <p>I have also a keen interest in coding, and have solved quite some problems in leetcode, geeeksforgeeks and codechef.</p>
                <a href = "https://drive.google.com/file/d/1Y5tVzM9tNqDZPJkujWCt8SziemF2jE3e/view?usp=sharing" className="flat-button" target="_blank" rel='noreferrer'>DOWNLOAD RESUME</a>
            </div>
            <div className="sphere-zone">
                <RevolvingText />
            </div>
        </div>
        <Loader type="ball-spin-fade-loader" />
        </>
    );
}

export default Skills;